module.exports = __webpack_public_path__ + "img/seierstad_Bokhandleren_i_Kabul3.19dafd54.jpg";